import { FormattedMessage } from 'react-intl';
import RemoveCrossIcon from '../../../assets/icons/remove-cross.svg?react';
import s from './FacilityButton.module.scss';

interface RemoveFacilityButtonProps {
  /** click handler function */
  onClick: () => void;
}

/**
 * Remove facility button
 */
function RemoveFacilityButton({ onClick }: RemoveFacilityButtonProps) {
  return (
    <button type="button" onClick={onClick} className={s.wrapper}>
      <RemoveCrossIcon role="presentation" focusable="false" />
      <FormattedMessage id="offerWizard.removeFacility" />
    </button>
  );
}

export default RemoveFacilityButton;
